export default __webpack_public_path__ + "static/media/not-helpful-selected-reaction.bf442e14.svg";